module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"visit":"Visit {0}","missing":"Missing screenshot of {0}"},"nl":{"visit":"Bezoek {0}","missing":"Ontbrekende schermafbeelding van {0}"}}')
  delete Component.options._Ctor
}
